module.exports = [{"componentChunkName":"component---src-pages-game-jsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-jsx","jsonName":"game.json","path":"/game/"},{"componentChunkName":"component---src-pages-index-jsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-jsx","jsonName":"index.json","path":"/"}]


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = 348
// module chunks = 231608221292675